import React, { useState, useEffect } from 'react';
import "../css/Events.css";
import { Grid, Modal, Button, Icon, Loader, Dimmer } from 'semantic-ui-react';
import MapPicker from 'react-google-map-picker';
import EventCard from './EventCard';
import EventComment from './EventComment';
import EventPostComment from './EventPostComment';


export default function EventModal({ event, idx }) {
    // const [location, setLocation] = useState({ lat: 28.6024274,  lng: -81.2000599 });
    // const [eventMap, setEventMap] = useState();
    return (
        <div>
            <Grid.Column key={idx}>
                <Modal
                    trigger={<EventCard date={event.date} startTime={event.startTime} event_name={event.event_name} description={event.description}></EventCard>} 
                    closeIcon
                    className='events-event-modal'
                >
                <Modal.Content scrolling>
                    <div className='events-info-container'>
                        <Grid columns={2}>
                            <Grid.Column>
                                <Button className='events-date-bttn'>
                                    <Icon name='calendar outline' />{event.date}
                                </Button>
                                <Button className='events-time-bttn'>
                                    <Icon name='clock outline' />{event.startTime} - {event.endTime}
                                </Button>
                                <p className='events-event-info-name'>{event.event_name}</p>
                                <p className='events-event-info-desc'>{event.description}</p>
                                <div className='events-event-info-location-contact'>
                                    <Icon name='map marker alternate' className='events-event-icon'/>{event.lname}
                                    <br />
                                    <Icon name='phone' className='events-event-icon'/>{event.phone_no}
                                </div>
                            </Grid.Column>
                            <Grid.Column>
                                {/* {eventMap ? 
                                    {eventMap}
                                    :
                                    <Dimmer active inverted>
                                        <Loader inverted content='Loading' />
                                    </Dimmer>
                                } */}
                                <MapPicker apiKey="AIzaSyCiA-Lw4YtdQcrQuqNcscM5II9082B5m6k" defaultLocation={{ lat: event.latitude,  lng: event.longitude }} zoom={16} className="events-map" style={{height: "55vh"}}></MapPicker>
                            </Grid.Column>
                        </Grid>
                    </div>
                    <h2 className='events-comments-title'>Comments</h2>
                    <div className='events-info-container'>
                        <EventComment eventid={event.eventid} />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <EventPostComment eventid={event.eventid} />
                </Modal.Actions>
                </Modal>
            </Grid.Column>
        </div>
    )

    // function renderMap() {
    //     let map = () => {
    //         return (
    //             <MapPicker apiKey="AIzaSyCiA-Lw4YtdQcrQuqNcscM5II9082B5m6k" defaultLocation={{ lat: event.latitude,  lng: event.longitude }} zoom={16} className="events-map" style={{height: "55vh"}}></MapPicker>
    //         );
    //     };
    //     setEventMap(map);
    // }
}